import styles from "./ErrorFallbackMessage.module.css";
import classNames from "classnames";
import { Link } from "../Link";
import emoji_surprised from "../../assets/icons/emoji_surprised.png";

import type { JSX } from "react";

type ErrorFallbackMessageProps = {
  signUpUrl?: string;
};

const ErrorFallbackMessage = (props: ErrorFallbackMessageProps): JSX.Element => {
  const { signUpUrl } = props;

  const appClasses = classNames(styles.foundation, styles.typography, styles.customVariables, styles.app);

  return (
    <div className={appClasses}>
      <div className={styles.layoutContainer}>
        <section className={styles.errorFallbackMessage}>
          <p className={classNames(styles.paragraph, styles.numbers)}>
            <span className={styles.calculation}>1 + 1 = 5</span>
            <span className={styles.calculation}>22 + 7 = 92</span>
            <span className={styles.calculation}>90 + 1.200 = 2.090</span>
          </p>
          <p className={classNames(styles.paragraph, styles.message)}>
            <img src={emoji_surprised} alt="" aria-hidden="true" className={styles.icon} />
            <span>Irgendwie haben wir uns ganz schön verrechnet.</span>
          </p>
          <p className={styles.paragraph}>
            Wir bringen unseren JobRad<sup>®</sup>-Rechner in Ordnung, <wbr /> um dir deine monatliche Rate und
            Ersparnis <wbr />
            zuverlässig berechnen zu können. <wbr />
            <b>Komm’ später wieder.</b>
          </p>
          {signUpUrl && (
            <p className={styles.paragraph}>
              Wie wäre es, wenn du dich in der Zwischenzeit <wbr />
              schon mal{" "}
              <Link id="link-signUp" to={signUpUrl}>
                registrierst
              </Link>
              ?
            </p>
          )}
        </section>
      </div>
    </div>
  );
};

export { ErrorFallbackMessage };
